<template>
  <div>
    <div class="lang-entry" @click="show = true">{{ currentLabel }}</div>
    <!-- @click.stop 必须加：vant 2 的 popup 不是 teleport 到 body 的，它就地渲染在
         本组件内；而宿主（Setting 的 .item、login 的导航栏）给外层绑了 show = true。
         不拦住冒泡的话 choose() 刚把 show 置 false，事件继续冒泡又置回 true，
         弹层关不掉。 -->
    <van-popup v-model="show" position="bottom" @click.stop>
      <van-nav-bar :title="$t('lang.title')" />
      <van-cell-group>
        <van-cell v-for="l in langs" :key="l.code" :title="l.label"
          :icon="l.code === current ? 'success' : ''"
          @click="choose(l.code)" />
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import { LANGS, switchLang } from '../lang'

export default {
  name: 'LangSwitch',
  data() {
    return { show: false, langs: LANGS }
  },
  computed: {
    // 授权改良：current 只读自全局 i18n 实例（原计划为 data 手动同步，
    // login 与 Setting 两个实例各持副本，一处切换另一处不会更新）
    current() {
      return this.$i18n.locale
    },
    currentLabel() {
      const hit = this.langs.filter(l => l.code === this.current)
      return hit.length ? hit[0].label : 'Language'
    }
  },
  methods: {
    choose(code) {
      switchLang(code)
      this.$store.commit('SET_LANG', code)
      // titleKey（Task 10 落地）优先翻译；未落地期间保持既有中文页面标题，避免切语言丢页面上下文
      const meta = this.$route.meta || {}
      document.title = meta.titleKey ? this.$t(meta.titleKey) : (meta.title || this.$t('common.appName'))
      this.show = false
    }
  }
}
</script>

<style lang="less" scoped>
/* base.css 全局将 .van-nav-bar__title 设为白色，弹层 nav-bar 默认白底会不可见，恢复深色 */
.van-popup ::v-deep .van-nav-bar__title {
  color: #323233;
}
/* 弹层内容放大到 750 设计稿文字尺度（vant 默认 14px 在 vw 方案下渲染过小），
   并避免宿主页全局 van-icon 字号（如登录页 ::v-deep 50px）影响弹层勾选图标 */
.van-popup ::v-deep .van-cell {
  font-size: 30px;
  line-height: 40px;
  padding: 30px 40px;
}
.van-popup ::v-deep .van-cell .van-icon {
  font-size: 32px;
}
.lang-entry {
  cursor: pointer;
}
</style>
